<template>
  <p class="text-red-500 opacity-80 text-left text-xs whitespace-nowrap overflow-hidden">
    <slot />
  </p>
</template>